import { create } from "zustand/react";
import { useShallow } from "zustand/react/shallow";

interface OrganizationsStore {
  state: string;
  searchKeyword: string;
  actions: {
    setSearchKeyword: (keyword: string) => void;
    unMount: () => void;
    setState: (state: string) => void;
  };
}

const defaultOrganizationsStoreData = {
  state: "active",
  searchKeyword: "",
};

const useOrganizationStore = create<OrganizationsStore>((set) => ({
  ...defaultOrganizationsStoreData,
  actions: {
    setSearchKeyword: (keyword) =>
      set(() => ({
        searchKeyword: keyword,
      })),
    unMount: () =>
      set(() => ({
        ...defaultOrganizationsStoreData,
      })),
    setState: (state) =>
      set(() => ({
        state,
      })),
  },
}));

// https://github.com/pmndrs/zustand?tab=readme-ov-file#selecting-multiple-state-slices
export const useOrganizationsData = () =>
  useOrganizationStore(
    useShallow((state) => ({
      state: state.state,
      searchKeyword: state.searchKeyword,
    })),
  );

export const useOrganizationsActions = () =>
  useOrganizationStore((state) => state.actions);
